/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import { utils } from '@lib/azgaz-ui/connect';

import { useFilterProps, useInitFilter } from '@/hooks';
import { CarsList, CarsBar, CarsLoadmore } from '../index';
import outsideComponents from '../../outsideComponents';
import CarFilterFixed from '../CarFilterFixed';

type CarsProps = {
  form: any;
};

const Cars: FC<CarsProps> = ({ form }: CarsProps) => {
  const { CarsFilters } = outsideComponents;

  const commonFilterProps = useInitFilter({ form });
  const filterProps = useFilterProps();
  const fixedFilterProps = useFilterProps({ initShow: false });

  console.log(commonFilterProps);

  return (
    <>
      {CarsFilters && (
        <CarFilterFixed
          isShowPanel={
            !!fixedFilterProps.collapseActiveKey?.length &&
            fixedFilterProps.showFilter
          }
          onChangeShow={fixedFilterProps.onChangeShow}
          onChangeActiveKey={fixedFilterProps.onChangeActiveKey}
          filterComponent={
            <CarsFilters {...fixedFilterProps} {...commonFilterProps} />
          }
        />
      )}
      {CarsFilters && <CarsFilters {...filterProps} {...commonFilterProps} />}
      <CarsBar />
      <CarsList />
      <CarsLoadmore />
    </>
  );
};

export default utils.withForm(Cars);
